import Vue from 'vue'
import VueFinalModal from 'vue-final-modal/lib'
Vue.use(VueFinalModal())